// Central site content for TAO LUMIN
export const ASSETS = {
  logoIcon:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_593c7add-b54b-46f4-8378-e7c0f128ee44/artifacts/dqh464yb_TaoLumin%20Icon_Color%20V2%203k.webp",
  wordmark:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/cmk3czor_TL%20Text%20Logo%20V6.1.1%203k.webp",
  iconBW:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/aq6oygju_TaoLumin%20Icon_BW%20V1.1%203k.webp",
  headshot:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/9533im2h_Tao%20Lumin%20-%20HS%2002.png",
  headshotStudio:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/6xhgwz17_Tao%20Lumin%20-%20HS%2001.webp",
  djBoothNight:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_593c7add-b54b-46f4-8378-e7c0f128ee44/artifacts/54svns27_IMG_0908.webp",
  beachSet:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/ghprptnh_IMG_2334.webp",
  marinaSet:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_klein-blue-sound/artifacts/c3nbvkbu_DE11D528-900D-4A45-891D-DB97120FF8CD.webp",
  tropicalHaze:
    "https://images.unsplash.com/photo-1768245075004-a4758cbceaa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMGZvbGlhZ2UlMjBzaWxob3VldHRlJTIwbmlnaHR8ZW58MHx8fHwxNzg0NDk0MzkxfDA&ixlib=rb-4.1.0&q=85",
  crowdLighting:
    "https://images.unsplash.com/photo-1429514513361-8fa32282fd5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxkYXJrJTIwY29uY2VydCUyMGNyb3dkJTIwYmx1ZSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NDQ5NDM5MXww&ixlib=rb-4.1.0&q=85",
};

export const SOCIALS = {
  instagram: "https://www.instagram.com/taolumin/",
  soundcloud: "https://soundcloud.com/tao_lumin",
  youtube:
    "https://www.youtube.com/watch?v=5ehhGJ3-xiI&list=RD5ehhGJ3-xiI&start_radio=1",
  linkedin: "https://www.linkedin.com/in/tao-lumin/",
};

export const CONTACT = {
  phone: "+1 (242) 428-4339",
  email: "tao.lumin.official@gmail.com",
  base: "Nassau, The Bahamas",
};

export const STATS = [
  { value: "2016", label: "Behind the decks since" },
  { value: "House", label: "Signature genre" },
  { value: "24242", label: "Nassau, Bahamas", hidden: true },
];

export const HERO_STATS = [
  { k: "Est.", v: "2016" },
  { k: "Genre", v: "House" },
  { k: "Base", v: "Nassau, BS" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Origin",
    body:
      "Born in Europe and raised in Nassau, The Bahamas since the age of three, TAO LUMIN stepped behind the decks at just fifteen — the start of a decade of reading rooms, chasing frequencies and learning exactly when to let a crowd breathe.",
  },
  {
    num: "02",
    title: "The Training",
    body:
      "At fifteen he trained at Dr. Dre's Scratch DJ Academy in Miami and New York, sharpening his technique at the source and grounding raw instinct in real craft.",
  },
  {
    num: "03",
    title: "The Pioneer",
    body:
      "Alongside Ethan Knowles (Eternic), TAO LUMIN is a pioneer of house music in The Bahamas — among the very first DJs to bring and popularize house in Nassau.",
  },
  {
    num: "04",
    title: "The Spectrum",
    body:
      "TAO LUMIN doesn't play one lane — he plays the whole spectrum of house. From chilled, sun-soaked lounge grooves to deep, funk-driven rhythms and high-energy peak-time house, every set is built to move with the room.",
  },
  {
    num: "05",
    title: "The Journey",
    body:
      "More than a DJ, TAO LUMIN is a guide. His signature is the journey — a carefully paced arc that takes a crowd from easy, golden-hour warmth to the euphoric heights of the night, and back again.",
  },
  {
    num: "06",
    title: "The Mission",
    body:
      "Facilitating a global evolution of the local music scene in The Bahamas — empowering the dreams and aspirations of native artists, and carrying the island's sound to the world.",
  },
];

export const SHOWS = [
  { venue: "Jazz Club, Baha Mar", place: "Nassau, Bahamas", tag: "Performance" },
  { venue: "SHIMA: After_Dark", place: "Island House, Bahamas", tag: "Club" },
  { venue: "Señor Frogs NYE Event", place: "Nassau, Bahamas", tag: "Event" },
  { venue: "Royal Nassau Sailing Club", place: "Nassau, Bahamas", tag: "Private" },
  { venue: "Old Fort Bay", place: "Private Events, Bahamas", tag: "Private" },
  { venue: "Studio Cafe", place: "Nassau, Bahamas", tag: "Performance" },
  { venue: "Sapodilla Events", place: "Nassau, Bahamas", tag: "Event" },
];

export const RESIDENCIES = [
  "Island House",
  "Lukka Kairi",
  "Margaritaville Beach Resort",
  "The London Restaurant",
  "Surge Events",
  "Bahamas National Symphony Orchestra",
  "Bahamas National Youth Orchestra",
];


export const VIDEOS = [
  { src: "/videos/clip1.mp4", label: "MAISON Forbes Global Property Showing", portrait: false },
];

export const TRUSTED = [
  "Baha Mar",
  "Island House",
  "Margaritaville",
  "Forbes Global Properties",
  "Royal Nassau Sailing Club",
  "Lukka Kairi",
];

export const EVENT_TYPES = [
  "Club Night",
  "Private Party",
  "Wedding",
  "Corporate / Brand",
  "Festival",
  "Lounge / Dinner",
  "Other",
];
